import { Injectable } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { Observable } from 'rxjs';
import { UserGameProfileApi } from '../+api';
import { UserGameProfileInterface } from '../+models';
import { UserGameProfileServiceInterface } from './user-game-profile.service.interface';

@Injectable({
  providedIn: 'root',
})
export class UserGameProfileService implements UserGameProfileServiceInterface {
  constructor(private userGameProfileApi: UserGameProfileApi) {}

  public getUserGameProfiles(keys: string[], methodCode: string): Observable<Dictionary<UserGameProfileInterface>> {
    return this.userGameProfileApi.getUserGameProfiles(methodCode, keys);
  }

  public saveUserGameProfile(userProfile: UserGameProfileInterface): Observable<UserGameProfileInterface> {
    return this.userGameProfileApi.saveUserGameProfile(userProfile);
  }
}
